import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    name: null, // Tên nhóm
    owner_id: null, // Chủ phòng
    avatar_id: null, // Ảnh avatar
    config: { // Cấu hình thêm cho phòng chát
        is_private: null, // Phòng riêng hay không
        limit_active_member: 20, // Số lượng member giới hạn trong phòng
        is_show_history: null, // Có show lịch sử chát cho member mới không
        is_send_notification: null, // Có gửi notification when có message mới không
    },
    inviting_member_ids: [], // Danh sách người được mời vào nhóm
    active_member_ids: [], // Danh sách những thành viên đang hoạt động trong nhóm
    leave_member_ids: [], // Danh sách những thành viên đã rời nhóm
    nhom_benh_ids: [], // Danh sách nhóm bệnh,
    nhomBenhId: undefined,
    responsible_doctors: [] // Danh sách bác sỹ chịu trách nhiệm trả lời nhóm
};

// validation form
model.validForm = {
    name: [ValidService.required], // Tên nhóm
    owner_id: [ValidService.required], // Chủ phòng
    avatar_id: [],
    config: { // Cấu hình thêm cho phòng chát
        is_private: [], // Phòng riêng hay không
        limit_active_member: [ValidService.checkPositiveNumberInteger], // Số lượng member giới hạn trong phòng
        is_show_history: [], // Có show lịch sử chát cho member mới không
        is_send_notification: [], // Có gửi notification when có message mới không
    },
    inviting_member_ids: [], // Danh sách người được mời vào nhóm
    active_member_ids: [], // Danh sách những thành viên đang hoạt động trong nhóm
    leave_member_ids: [], // Danh sách những thành viên đã rời nhóm
    nhom_benh_ids: [], // Danh sách nhóm bệnh
    nhomBenhId: [ValidService.requiredChangeRoom],
};


// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhTinTuc: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

// validation các form khác
model.validFormOther = {
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["created_time", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            $vn_text: "",
            nhom_benh_ids: ""
        },
        valid: {
            $vn_text: [],
            nhom_benh_ids: []
        },
        operator: {
            // $vn_text: "", //:regex:, $vn_text=Viêt nam
            nhom_benh_ids: ":in:"
        }
    }
};

export default model;